import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { errorToast } from "../../../components/toastmessage/toastmessage";
import { fetchBedApiCall } from "./bedService";
import { sassTrue } from "sass";


const useBedTableHook = () => {
    const navigate = useNavigate();
    const [bedState, setBedState] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const fetchBeds = async () => {
            setLoader(sassTrue)
            try {
                let result = await fetchBedApiCall();
                if (result.status === 200) {
                    setLoader(false)
                    setBedState(result?.data?.result)
                }
            } catch (e) {
                setLoader(false)
                errorToast("Failed to fetch Rooms")
            }

        }
        fetchBeds();

    }, []);

    const handleDelete = (e, id) => {
        e.preventDefault();
        setBedState(oldValues => {
            return oldValues.filter(room => room?.bedID !== id?.bedID)
        });
    };

    const handleGetRowId = (e) => {
        return e?.bedID
    }

    const handleAddBed = () => {
        navigate("/master/add-bed")
    }
    return {
        bedState,
        loader,
        handleGetRowId,
        handleDelete,
        handleAddBed
    }


};


export default useBedTableHook;
